// Reducer imports:
import { combineReducers } from 'redux';
import loginReducer, { ILoginState } from './loginReducer';
import privateReducer, { IPrivateState } from './privateReducer';
import publicReducer, { IPublicState } from './publicReducer';
import alertReducer, { IAlertsState } from './alertReducer';
import bookmarkReducer, { IBookmarkState } from './bookmarkReducer';
import dashboardReducer, { IDashboardState } from './dashboardReducer';
import newsReducer, { INewsState } from './newsReducer';
import reportReducer, { IReportState } from './reportReducer';

export type RootState = {
    loginReducer: ILoginState,
    privateReducer: IPrivateState,
    publicReducer: IPublicState,
    alertReducer: IAlertsState,
    bookmarkReducer: IBookmarkState,
    dashboardReducer: IDashboardState,
    newsReducer: INewsState,
    reportReducer: IReportState
}

const rootReducer = combineReducers({
    loginReducer,
    privateReducer,
    publicReducer,
    alertReducer,
    bookmarkReducer,
    dashboardReducer,
    newsReducer,
    reportReducer
});

export default rootReducer;